export const LoaderComponent = {
  bindings: {},
  templateUrl: 'components/Loaders/loader/loader.html',
};
